/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "network": {
            "nested": {
              "Datacenter": {
                "values": {
                  "MTV": 1,
                  "SJC1": 2,
                  "SJC1B": 3,
                  "LAB": 4,
                  "EC2": 5,
                  "IAD1": 6,
                  "NRT1": 7,
                  "SJC1C": 8,
                  "LOCAL": 9,
                  "CORP": 10,
                  "PLAY": 11,
                  "SJC1_2": 12,
                  "HQ": 13,
                  "AWS": 14,
                  "UNIVERSE": 15,
                  "SJC2B": 16,
                  "IAD2B": 17,
                  "LOCAL_2": 18,
                  "GCP": 19,
                  "IAD3B": 20,
                  "SJC2B_SANDBOX": 21,
                  "IAD3A": 22,
                  "SJC3B": 23,
                  "NRT1B": 24,
                  "IAD3A_2": 25,
                  "EXTERNAL": 100
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.network?.nested?.Datacenter) {
  $root.addJSON(jsonData);
}

/**
 * List of Square datacenters.
 *
 * SOURCE Datacenter @ squareup/common/network.proto at 7:1
 */
export const Datacenter = $root.lookupEnum('squareup.common.network.Datacenter').values;